// Wireframe outline drawn around the block the player is targeting.

import * as THREE from 'three';
import { Vec3 } from '../sim/math';

export class BlockHighlight {
  private mesh: THREE.LineSegments;

  constructor(scene: THREE.Scene) {
    const box = new THREE.BoxGeometry(1.002, 1.002, 1.002);
    const edges = new THREE.EdgesGeometry(box);
    const mat = new THREE.LineBasicMaterial({ color: 0x000000, transparent: true, opacity: 0.4 });
    this.mesh = new THREE.LineSegments(edges, mat);
    this.mesh.visible = false;
    this.mesh.renderOrder = 2;
    scene.add(this.mesh);
  }

  show(block: Vec3): void {
    this.mesh.visible = true;
    this.mesh.position.set(block.x + 0.5, block.y + 0.5, block.z + 0.5);
  }

  hide(): void {
    this.mesh.visible = false;
  }
}
